import * as React from "react";
const SvgCross = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17 7L7 17M7 7L17 17", stroke: "#64748b", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgCross;
